<template>
    <div class="pushdatasetting-box">
        <div class="head">
            <div class="op-box">
                <el-button size="mini" type="primary" @click="add" icon="el-icon-plus">添加</el-button>
                <el-button size="mini" style="color: #E6A23C" type="text" @click="edit"><i><svg-icon style="width:1.2em; height: 1.2em; padding-left: 1rem" icon-class="修改"></svg-icon></i>&nbsp;修改</el-button>
                <el-button size="mini" style="color: #F56C6C" type="text" @click="remove"><i><svg-icon style="width:1.2em; height: 1.2em; padding-left: 1rem" icon-class="停用"></svg-icon></i>&nbsp;删除</el-button>
            </div>
        </div>
        <div class="pushdatasetting-table-box">
            <el-table class="pushdatasetting-table" :data="dataInfo" height="100%" width="100%" @row-click="currClick" :header-row-style="{color:'black'}" size="small" highlight-current-row>
                <el-table-column
                        align="center"
                        prop="alarmUrl"
                        label="报警推送地址">
                </el-table-column>
                <el-table-column
                        align="center"
                        prop="paramUrl"
                        label="数据推送地址">
                </el-table-column>
                <el-table-column
                        align="center"
                        prop="authorizationToken"
                        label="客户授权码">
                </el-table-column>
                <el-table-column
                        align="center"
                        prop="paramPushTimeInterval"
                        label="数据推送频率（分钟）"
                        width="100">
                </el-table-column>
            </el-table>
        </div>

        <el-dialog title="数据转发设置" :visible.sync="dialogFormVisible" width="45rem" top="15vh" size="small">
            <template slot="title">
                数据转发设置
            </template>
            <el-form :model="newData" :rules="rules" ref="ruleForm" size="small" inline>
                <div class="item-group">
                    <el-form-item label="报警推送地址" prop="alarmUrl" >
                        <el-input v-model="newData.alarmUrl" placeholder="请输入报警推送地址" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="客户授权码" prop="authorizationToken">
                        <el-input v-model="newData.authorizationToken" placeholder="请输入客户授权码" autocomplete="off"></el-input>
                    </el-form-item>
                </div>
                <div class="item-group">
                    <el-form-item label="数据推送地址" prop="paramUrl">
                        <el-input v-model="newData.paramUrl" placeholder="请输入数据推送地址" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="数据推送频率" prop="paramPushTimeInterval">
                        <el-select v-model="newData.paramPushTimeInterval" placeholder="请选择客户推送频率">
                            <el-option :key="0" :value="0" label="即时发送"></el-option>
                            <el-option :key="5" :value="5" label="5分钟"></el-option>
                            <el-option :key="15" :value="15" label="15分钟"></el-option>
                            <el-option :key="30" :value="30" label="30分钟"></el-option>
                            <el-option :key="60" :value="60" label="1小时"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <div class="item-group">
                    <el-form-item label="推送报警类型" prop="alarmType">
                        <el-checkbox-group v-model="newData.alarmTypeList">
                            <el-checkbox-button v-for="type in alarmType" :label="type.warningType" :key="type.warningType">{{type.name}}</el-checkbox-button>
                        </el-checkbox-group>
                    </el-form-item>
                </div>
                <div class="item-group">
                    <div style="width: 49%; float: left">
                        <span>测量参数树</span>
                        <div style="height: 1rem"></div>
                        <div style="height: 36vh; overflow: auto">
                            <el-tree
                                    ref="meterTree"
                                    :data="meterTree"
                                    show-checkbox
                                    node-key="code"
                                    :default-checked-keys="meterTreeChecked"
                                    @check="meterTreeCheck"
                                    @check-change="meterTreeCheck"
                                    :props="meterTreeProps">
                            </el-tree>
                        </div>
                    </div>
                    <div style="width: 49%; float: right">
                        <span>测量参数类型</span>
                        <div style="height: 1rem"></div>
                        <div style="height: 36vh; overflow: auto">
                            <el-checkbox-group v-model="checkedMpTypes" size="mini" @change="mpTypeChange">
                                <template v-for="(oneType,index) in measureTypeTree">
                                    <div style="font-size: 14px;width:100%;line-height: 25px;height: 25px;box-sizing: border-box; border-left: 2px solid rgb(120,255,253);">{{oneType.name}}</div>
                                    <div style="padding-left: 10px" v-for="twoType in oneType.children">
                                        <div v-if="twoType.children.length > 0">
                                            <el-checkbox-button v-for="mpType in twoType.children" :label="mpType.code" :key="mpType.code" :value="mpType.code"></el-checkbox-button>
                                        </div>
                                        <div v-else>
                                            <el-checkbox-button :label="twoType.code" :key="twoType.code" :value="twoType.code"></el-checkbox-button>
                                        </div>
                                    </div>
                                </template>
                            </el-checkbox-group>
                        </div>
                    </div>
                </div>
            </el-form>

            <span slot="footer" class="dialog-footer">
			<el-button type="primary" @click="save">保存</el-button>
			<el-button @click="cancel">取 消</el-button>
		</span>
        </el-dialog>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { Message } from 'element-ui'
import { getDataByCustmerId, getTree, getMeasureType, getWaringType, saveOrUpdate, del } from "@/api/pushDataSetting";

export default {
  name: "pushdatasetting",
  data(){
    let checkUrl = (rule, value, callback) => {
      if(value){
        // 验证url
        var strRegex = "^((https|http)?://)" + "?(([0-9a-z_!~*'().&=+$%-]+: )?[0-9a-z_!~*'().&=+$%-]+@)?" //ftp的user@
          + "(([0-9]{1,3}\.){3}[0-9]{1,3}" // IP形式的URL- 199.194.52.184
          + "|" // 允许IP和DOMAIN（域名）
          + "([0-9a-z_!~*'()-]+\.)*" // 域名- www.
          + "([0-9a-z][0-9a-z-]{0,61})?[0-9a-z]\." // 二级域名
          + "[a-z]{2,6})" // first level domain- .com or .museum
          + "(:[0-9]{1,4})?" // 端口- :80
          + "((/?)|" // a slash isn't required if there is no file name
          + "(/[0-9a-zA-Z_!~*'().;?:@&=+$,%#-]+)+/?)$";
        var re = new RegExp(strRegex);
        if(re.test(value)){
          callback();
        } else {
          callback(new Error('请输入正确的URL地址'));
        }
      } else {
        callback();
      }
    };
    return{
      dataInfo: [],
      flag:{
        addFlag:true,editFlag:true,removeFlag: true
      },
      dialogFormVisible: false,
      formLabelWidth: '110px',
      newData:{},
      meterTree:[],
      meterTreeChecked:[],
      meterTreeProps:{
        children: 'children',
        label: 'name'
      },
      measureTypeTree:[],
      checkedMpTypes:[],
      alarmType:[],
      rules: {
        //1、要验证url 2、验证报警类型 3、数据权限
        alarmUrl: [
          /*{ required: true, message: '请输入报警推送地址', trigger: 'blur' },*/
          { validator: checkUrl, trigger: ['blur','change'] }
        ],
        paramUrl: [
          /*{ required: true, message: '请输入参数数据推送地址', trigger: 'blur' },*/
          { validator: checkUrl, trigger: ['change','blur'] }
        ],
        /*alarmType: [
          {required: true, message: '报警类型必选（单选或多选）', trigger: 'blur'}
        ]*/
      }
    }
  },
  computed: {
    ...mapGetters([
      'customerId'
    ])
  },
  mounted() { /* 页面初始化完成加载数据*/
    this.fetchData()
    //获取仪表树
    this.getMeterTree();
    //获取测量参数类型
    this.getMeasureTypeTree();
    //获取报警类型
    this.getAlarmType();
  },
  methods: {
    cancel: function(){
      this.dialogFormVisible = false
      this.newData = {}
    },
    remove: function(){
      if(Object.keys(this.newData).length === 0){
        Message({
          message: "请选择需要删除的记录",
          type: 'warning',
          duration: 5 * 1000
        })
      }else{
        del(this.newData).then(res =>{
          if(res.code === 200){
            Message({
              message: res.message,
              type: 'success',
              duration: 5 * 1000
            })
            this.newData = {}
            this.fetchData()
          }else{
            Message({
              message: res.message,
              type: 'error',
              duration: 5 * 1000
            })
          }
        })
      }
    },
    edit: function(){
      if(Object.keys(this.newData).length === 0){
        Message({
          message: "请选择需要修改的记录",
          type: 'warning',
          duration: 5 * 1000
        })
      }else{
        this.meterTreeChecked.splice(0,this.meterTreeChecked.length);
        if(this.$refs.meterTree){
          this.$refs.meterTree.setCheckedKeys([]);
        }
        this.meterTreeChecked = []
        this.checkedMpTypes = []
        this.newData.paramDataList.forEach(paramData =>{
          //paramData = "test1_acubilltest","test1_acubilltest_C2_B10C1_2010p","test1_acubilltest_C2_B10C1_2010p_Ep"
          let temp = paramData.split("_")
          //长度为6的是参数
          if(temp.length === 6){
            this.meterTreeChecked.push(paramData)
            this.checkedMpTypes.push(temp[5])
          }
        })
        this.dialogFormVisible = true;
      }
    },
    currClick: function (val) {
      let data = Object.assign({}, val)
      this.newData = {
        id: data.id,
        alarmUrl: data.alarmUrl,
        paramUrl: data.paramUrl,
        authorizationToken: data.authorizationToken,
        paramPushTimeInterval: data.paramPushTimeInterval,
        paramDataList: JSON.parse(data.paramData),
        paramData: data.paramData,
        alarmTypeList: JSON.parse(data.alarmType),
        alarmType: data.alarmType,
        customerId: this.customerId,
      }
    },
    save: function(){
      this.newData.paramData = JSON.stringify(this.newData.paramDataList)
      this.newData.alarmType = JSON.stringify(this.newData.alarmTypeList)
      debugger
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          if(this.newData.alarmUrl === "" && this.newData.paramUrl === ""){
            Message.warning("请输入推送地址")
            return
          }
          if(this.newData.alarmUrl !== ""){
            if(this.newData.alarmTypeList.length === 0){
              Message.warning("推送报警类型必选（单选或多选）")
              return
            }
          }
          if(this.newData.paramUrl !== ""){
            if(this.newData.paramDataList.length === 0){
              Message.warning("推送参数必选（单选或多选）")
              return
            }
          }
          saveOrUpdate(this.newData).then(res =>{
            if(res.code === 200){
              Message({
                message: res.message,
                type: 'success',
                duration: 5 * 1000
              })
              delete this.newData.paramDataList
              delete this.newData.alarmTypeList
              this.newData = {}
              this.fetchData()
            }else{
              Message({
                message: res.message,
                type: 'error',
                duration: 5 * 1000
              })
            }
            this.dialogFormVisible = false
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    fetchData: function () {
      getDataByCustmerId(this.customerId).then(res => {
        if(res.code == 200){
          this.dataInfo = res.infoJson
        }
      })
    },
    add: function() {
      this.checkedMpTypes = [];
      this.meterTreeChecked.splice(0,this.meterTreeChecked.length)
      if(this.$refs.meterTree){
        this.$refs.meterTree.setCheckedKeys([])
      }
      this.newData = {
        id: '',
        alarmUrl : '',
        paramUrl : '',
        authorizationToken : '',
        paramPushTimeInterval:0,
        paramDataList:[],
        paramData: '',
        alarmTypeList:[],
        alarmType: '',
        customerId: this.customerId,
      }
      this.dialogFormVisible = true
      //this.dialogFormTitle = '添加客户推送地址';
    },
    getMeterTree: function () {
      getTree(this.customerId).then(res => {
        if(res.code === 200) {
          this.meterTree = res.infoJson;
        }
      })
    },
    getMeasureTypeTree: function () {
      getMeasureType().then(res => {
        if(res.code === 200) {
          this.measureTypeTree = res.infoJson;
        }
      })
    },
    getAlarmType: function(){
      getWaringType().then(res => {
        if(res.code === 200) {
          this.alarmType = res.infoJson
        }
      })
    },
    meterTreeCheck: function () {
      let selectMpType = new Set()
      this.newData.paramDataList = []
      this.$refs.meterTree.getCheckedNodes(false,true).forEach(node =>{
        if(node.level == 3){
          selectMpType.add(node.name)
        }
        this.newData.paramDataList.push(node.code);
      })
      this.checkedMpTypes.splice(0,this.checkedMpTypes.length);
      selectMpType.forEach( type =>{
        this.checkedMpTypes.push(type)
      })
    },
    mpTypeChange: function(){
      let seletMptype = this.checkedMpTypes
      this.$refs.meterTree.getCheckedNodes(false,true).forEach(node =>{
        if(node.level == 2){
          this.$refs.meterTree.setChecked(node,false,true)
          node.children.forEach( c => {
            if(seletMptype.indexOf(c.name)>=0){
              this.$refs.meterTree.setChecked(c,true)
            }
          })
        }
      })
    },
  }
}
</script>
<style scoped rel="stylesheet/scss" lang="scss">
    .pushdatasetting-box {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        button {
            /*font-size: 14px;*/
            font-weight: bold;
        }
        .head{
            flex-direction: column;
            box-sizing: border-box;
            .collection-manage-condition-box{
                font-size: 0.875rem;
                display: flex;
                align-items: center;
                padding-top: 1%;
                padding-left: 2%;
                box-sizing: border-box;

            }
            .op-box {
                padding-left: 2%;
                padding-top: 1%;
                padding-bottom: 15px;
                /*padding-left: 1%;

                padding-bottom: 15px;*/
            }
        }
        .pushdatasetting-table-box {
            /* overflow: auto;
             max-height: 320px;
             height: auto;
             width: auto;
             display: block;
             align-items: center;*/
            flex: 4;

        }



        .el-table .warning-row {
            background: oldlace;
        }

        .div-hr {
            height: 1px;
            background-color: #dedede;
        }
    }
</style>